module.exports = __webpack_public_path__ + "static/media/red_compra.92579e07.svg";